import { render, staticRenderFns } from "./OnboardingQuestionDiabetes.vue?vue&type=template&id=7f924298"
import script from "./OnboardingQuestionDiabetes.vue?vue&type=script&lang=js"
export * from "./OnboardingQuestionDiabetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports